import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'data': [],
};

export const devicesStock = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_DEVICES_STOCK]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DEVICES_STOCK]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data,
    }),
    [ActionTypes.FETCHED_DEVICES_STOCK_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),
  })(state, action);
};
